<nz-spin [nzSpinning]="loading$ | async">
  <main id="check-production-dates-result">
    <ng-container *ngIf="data$ | async as payload">
      <ng-container *ngIf="payload.length; else noPayload">
        <section>
          <button nz-button nzType="default" nzSize="small" (click)="hideResult()">
            <span nz-icon nzType="close" nzTheme="outline"></span>
          </button>

          <ng-container *ngIf="checkHasError(payload); else estimatedDateBlock">
            <nz-alert [nzType]="'warning'" [nzMessage]="info">
              <ng-template #info>
                <div>
                  <b>{{ 'CHECK_PRODUCTION_DATE_PAGE.RESULT.error' | translate }}:</b>
                  {{ 'CHECK_PRODUCTION_DATE_PAGE.RESULT.info_not_found' | translate }}
                </div>
              </ng-template>
            </nz-alert>
          </ng-container>

          <ng-template #estimatedDateBlock>
            <ng-container *ngIf="checkHasEstimatedDate(payload); else result">
              <nz-alert [nzType]="'info'" [nzMessage]="estimatedDate">
                <ng-template #estimatedDate>
                  <div>
                    <b>{{ 'CHECK_PRODUCTION_DATE_PAGE.NO_PRODUCTION_DATA' | translate }}</b>
                    <p
                      >{{
                        'CHECK_PRODUCTION_DATE_PAGE.ESTIMATED_DATA'
                          | translate
                            : {
                                value1: getDateValue(payload, 'productionDateGte') | date: 'yyyy.MM.dd',
                                value2: getDateValue(payload, 'productionDateLte') | date: 'yyyy.MM.dd'
                              }
                      }}
                    </p>
                  </div>
                </ng-template>
              </nz-alert>
            </ng-container>

            <ng-template #result>
              <nz-alert [nzType]="'info'" [nzMessage]="info">
                <ng-template #info>
                  <div *ngFor="let data of payload">
                    <b>{{ 'CHECK_PRODUCTION_DATE_PAGE.RESULT.' + data.key | translate }}:</b>
                    {{ data.value }}
                  </div>
                </ng-template>
              </nz-alert>
            </ng-template>
          </ng-template>
        </section>
      </ng-container>
    </ng-container>
    <ng-template #noPayload>
      <nz-alert [nzType]="'error'" [nzMessage]="noData">
        <ng-template #noData>{{ 'CHECK_PRODUCTION_DATE_PAGE.NO_DATA' | translate }}</ng-template>
      </nz-alert>
    </ng-template>
  </main>
</nz-spin>
